// Imports ------------------------------------------------------------------->

import { Component, attr } from '../Component'
import { element } from '../CustomElement'
import { i18n } from '../../i18n/I18n'

// Private Definitions ------------------------------------------------------->

// Public Definitions -------------------------------------------------------->

/* This is to work around a problem where we need to embed links within a translated string yet
 * still take advantage of JSX.
 * The Login dialog uses a string where sections of text that are to be links are wrapped with
 *   {#n}my text{/b}
 * Where n is an integer representing the current link in the string
 * eg real string on loging dialog:
 *   'By signing in, you agree to Flipp\'s {#1}Terms{\\1} and {#2}Privacy Policy{\\2}'
 *
 * This component parses that string and generates JSX with links substitued as required.
 */

type LinkMap = { [key: number]: string }

interface I18nLinkProps {
    key: string
    // TODO: Automatically JSON.stringify everywhere this is used
    values: LinkMap
}

@element('flipp-i18n-link')
export class I18nLink extends Component<I18nLinkProps, LinkMap> {
    @attr key: string
    @attr values: string

    prepare() {
        return JSON.parse(this.values) as LinkMap
    }

    render(links: LinkMap) {
        const regex = /\{#\d\}(.*?)\{\\\d\}/g
        const text = i18n(this.key)
        const matches = text.match(regex)

        if (!text) {
            return null
        }

        return (
            <div>
                {matches.map((match, idx) => {
                    if (idx === 0) {
                        return (
                            <span>
                                {text.substring(0, text.indexOf(match))}
                                <a href={links[idx + 1]} target="_blank">
                                    {match.substring(4, match.length - 4)}
                                </a>
                                {matches.length === 1 ? (
                                    <span>
                                        {text.substring(
                                            text.indexOf(match) + match.length,
                                            text.length
                                        )}
                                    </span>
                                ) : null}
                            </span>
                        )
                    } else {
                        return (
                            <span>
                                {text.substring(
                                    text.indexOf(matches[idx - 1]) +
                                        matches[idx - 1].length,
                                    text.indexOf(match)
                                )}
                                <a href={links[idx + 1]} target="_blank">
                                    {match.substring(4, match.length - 4)}
                                </a>
                                {matches.length === idx + 1 ? (
                                    <span>
                                        {text.substring(
                                            text.indexOf(match) + match.length,
                                            text.length
                                        )}
                                    </span>
                                ) : null}
                            </span>
                        )
                    }
                })}
            </div>
        )
    }
}
